import {
  createHook,
  createStore,
  StoreActionApi,
} from "react-sweet-state";
import { Document } from "entities/UIModel/Document";

type State = {
  isTitleSearchGridInEditMode: boolean;
  isTitleSearchGridInShowToastMode: boolean;  
  selectedTitleSearchGridItems: Document[]; 
  messageIntegrationKey?: string;
};

type StoreApi = StoreActionApi<State>;
type Actions = typeof actions;

const actions = {
    setTitleSearchGridInEditMode:
      (isTitleSearchGridInEditMode: boolean) =>
      ({ setState }: StoreApi) => {
        setState({ isTitleSearchGridInEditMode });
      },
    setTitleSearchGridInShowToastMode:
      (isTitleSearchGridInShowToastMode: boolean) =>
      ({ setState }: StoreApi) => {
        setState({ isTitleSearchGridInShowToastMode });
      },
      setMessageIntegrationKey:
      (messageIntegrationKey?: string) =>
      ({ setState }: StoreApi) => {
        setState({ messageIntegrationKey });
      },

    updateSelectedTitleSearchGridItem:
      (item: Document) =>
      ({ setState, getState }: StoreApi) => {
        const currentItems = getState().selectedTitleSearchGridItems || [];
        const updatedItems = currentItems?.filter(
          (d) => d.documentID !== item.documentID
        );

        if (updatedItems.length === currentItems?.length) {
          updatedItems.push(item);
        }

        setState({
          selectedTitleSearchGridItems: updatedItems,
        });
      },
    updateSelectedTitleSearchGridItems:
      (items: Document[], orderID?: number) =>
      ({ setState, getState }: StoreApi) => {

        const currentSelectedAllItems =
          getState().selectedTitleSearchGridItems || [];

        const currentSelectedOrderItems = currentSelectedAllItems?.filter((d) => d.orderID === orderID);
        const currentSelectedOtherItems = currentSelectedAllItems?.filter((d) => d.orderID !== orderID);

        const newOrderItems = items.filter(
          (item) =>
            !currentSelectedOrderItems?.find(
              (currentItem) =>
                currentItem.documentID === item.documentID
            )
        );

        let updatedOrderItems: Document[] = [];
        if (newOrderItems.length > 0) {
          updatedOrderItems = currentSelectedOrderItems?.concat(newOrderItems);
        }        


        let updatedItems: Document[] = [];
        if (updatedOrderItems.length > 0 || currentSelectedOtherItems?.length > 0) {
          updatedItems = currentSelectedOtherItems?.concat(updatedOrderItems);
        }        



        // const currentTitleSearchGridItems =
        //   getState().selectedTitleSearchGridItems || [];

        // const newItems = items.filter(
        //   (item) =>
        //     !currentTitleSearchGridItems?.filter((d) => d.orderID === orderID)?.find(
        //       (currentItem) =>
        //         currentItem.documentID === item.documentID
        //     )
        // );

        // let updatedItems: Document[] = [];
        // if (newItems.length > 0) {
        //   updatedItems = currentTitleSearchGridItems?.concat(newItems);
        // }

        setState({
          selectedTitleSearchGridItems: updatedItems,
        });
      },
    resetSelectedTitleSearchGridItems:
      (orderID?: number) =>
      ({ getState, setState }: StoreApi) => {
        const currentTitleSearchGridItems =
          getState().selectedTitleSearchGridItems || [];        
        const updatedItems = currentTitleSearchGridItems?.filter((d) => d.orderID !== orderID);
        setState({
          selectedTitleSearchGridItems: updatedItems,
        });
      },

};

const Store = createStore<State, Actions>({
  initialState: {
    isTitleSearchGridInEditMode: false,
    isTitleSearchGridInShowToastMode: false,
    selectedTitleSearchGridItems: [],
    messageIntegrationKey: "",
  },
  actions,
  name: "titleSearch"
});


const useTitleSearchActions = createHook(Store, {
  selector: null,
});

// for later use
// const getTitleSearchStates = (state: State) => ({

// });

const getTitleSearchGridStates = (state: State) => ({
  isTitleSearchGridInEditMode: state.isTitleSearchGridInEditMode,
  isTitleSearchGridInShowToastMode: state.isTitleSearchGridInShowToastMode,
})

const getTheMessageIntegrationKey = (state: State) => ({
  messageIntegrationKey: state.messageIntegrationKey,
})

const getTitleSearchGridItems = (state: State) => ({
  selectedTitleSearchGridItems: state.selectedTitleSearchGridItems,
})

const useTitleSearchGridItems = createHook(Store, {
  selector: getTitleSearchGridItems,
})

const useTitleSearchGridStates = createHook(Store, {
  selector: getTitleSearchGridStates,
});

const useTitleSearchMessageIntegrationKey = createHook(Store, {
  selector: getTheMessageIntegrationKey,
});



export { 
  useTitleSearchActions, 
  useTitleSearchGridStates, 
  useTitleSearchGridItems,
  useTitleSearchMessageIntegrationKey,
};
